import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import {
  GridColumn,
  GridContainer,
  GridRow,
  Input,
  Label,
} from "arv-reactcomponents";
import LoyaltyOtp from "./LoyaltyOtp";
import LoyaltyToolTip from "./LoyaltyToolTip";
import { ToCurrency } from "../../utils";
import Analytics from "../../analytics";
import Event from "../../analytics/eventFactory";
import { PAYMENTPAGE } from "../../constants";

@inject("CommonStore")
@observer
class Loyalty extends Component {
  constructor() {
    super();
    this.state = {
      isLoyaltyChecked: false,
    };
    this.loyaltyCheckClick = this.loyaltyCheckClick.bind(this);
  }

  loyaltyCheckClick() {
    const isLoyaltyChecked = !this.state.isLoyaltyChecked;
    this.setState({ isLoyaltyChecked });
    this.props.loyaltyCheck(isLoyaltyChecked);
    Analytics.trackEvent({
      action: isLoyaltyChecked
        ? Event.action.LOYALTY_CHECKBOX_SELECTED
        : Event.action.LOYALTY_CHECKBOX_UNSELECTED,
      category: Event.category.CHECKOUT,
    });
  }

  get loyaltyValue() {
    const value =
      (this.props.loyalty &&
        this.props.loyalty.points &&
        this.props.loyalty.points.loyaltyValue) ||
      0;
    return ToCurrency(value);
  }

  get isShowOtpComponent() {
    return this.state.isLoyaltyChecked && !this.props.loyalty.verified;
  }

  render() {
    const { isDesktop } = this.props.CommonStore;
    
    return (
      <GridContainer className="">
        <GridRow className="nw-loyalty-checkrow">
          <GridColumn className="nwc-grid-col-sm-5 nwc-grid-col-xs-9 nw-loyalty-checkcol">
            <Label htmlFor="loyalty-points">
              <Input
                id="loyalty-points"
                type="checkbox"
                className="nwc-inp-checkbox-primary nw-loyalty-checkbox"
                value={this.loyaltyValue}
                checked={this.state.isLoyaltyChecked}
                onChange={() => {
                  this.loyaltyCheckClick();
                }}
              />
              <span>{PAYMENTPAGE.LOYALTY_POINTS_TEXT}</span>
            </Label>
          </GridColumn>
          <GridColumn className="nwc-grid-col-sm-7 nwc-grid-col-xs-3 nw-loyalty-colvalue">
            <span className="nw-loyalty-value">
              {ToCurrency(this.props.loyalty.points.loyaltyValue || 0)}
            </span>
            {isDesktop ? (
              <LoyaltyToolTip.component
                loyaltyPoints={
                  this.props.loyalty &&
                  this.props.loyalty.points &&
                  this.props.loyalty.points.brandLoyaltyList
                }
              />
            ) : null}
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn className="nw-loyalty-otpcol">
            {this.isShowOtpComponent ? (
              <LoyaltyOtp.component loyaltyCheck={this.props.loyaltyCheck} />
            ) : null}
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
  }
}

Loyalty.wrappedComponent.propTypes = {
  CommonStore: PropTypes.shape({
    isDesktop: PropTypes.bool.isRequired,
  }).isRequired,
  loyalty: PropTypes.shape({
    points: PropTypes.shape({
      loyaltyValue: PropTypes.number,
      brandLoyaltyList: PropTypes.shape({}),
    }).isRequired,
    verified: PropTypes.bool.isRequired,
  }).isRequired,
  loyaltyCheck: PropTypes.func.isRequired,
};

const getFinalComponent = component =>
  inject("CommonStore")(observer(component));;

const ProjectComponent = {
  getFinalComponent,
  wrapper: Loyalty.wrappedComponent,
  component: Loyalty,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/Loyalty/index.js